import React, { Fragment, useEffect, memo } from 'react';

import dynamic from 'next/dynamic';

import { number, func, oneOf } from 'prop-types';

import Main from '../Main';

const Absoluts = dynamic(() => import('../../containers/Absoluts'), { ssr: false });
const SnackBarProductAdd = dynamic(() => import('../../containers/SnackBarProductAdd'));
const GlobalSnackbar = dynamic(() => import('../../containers/GlobalSnackbar'));
const GlobalModal = dynamic(() => import('../../containers/GlobalModal'));

const HeaderA = dynamic(() => import(`../../containers/Templates/A/Header`));
const FooterA = dynamic(() => import(`../../containers/Templates/A/Footer`));

const HeaderB = dynamic(() => import(`../../containers/Templates/B/Header`));
const FooterB = dynamic(() => import(`../../containers/Templates/B/Footer`));

const templates = {
  A: {
    header: <HeaderA />,
    footer: <FooterA />,
  },
  B: {
    header: <HeaderB />,
    footer: <FooterB />,
  },
};

const Layout = ({ children, statusCode, setClientPlataform, template }) => {
  function handleResize() {
    if (window.innerWidth <= 768) {
      setClientPlataform('mobile');
    } else if (window.innerWidth > 768) {
      setClientPlataform('desktop');
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Fragment>
      {statusCode < 500 && templates[template]?.header}
      <Main>{children}</Main>
      {statusCode < 500 && templates[template]?.footer}
      {statusCode < 500 && <SnackBarProductAdd />}
      {statusCode < 500 && <GlobalSnackbar />}
      {statusCode < 500 && <GlobalModal />}
      {statusCode < 500 && <Absoluts />}
    </Fragment>
  );
};

Layout.propTypes = {
  statusCode: number,
  setClientPlataform: func,
  template: oneOf(['A', 'B']),
};

export default memo(Layout);
